// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_upload-document_upload-document_module_ts":"1c6cedb8c67bcdd2","src_app_supplier_supplier_module_ts":"cbca430741bc9235"}[chunkId] + ".js";
};